import AbstractGuestlistDetailsPageController from '../guestlists/abstract-details-controller';

export default class GuestlistRsvpsCreatePageController extends AbstractGuestlistDetailsPageController {
    constructor($scope, $injector) {
        super($scope, $injector);

        this.depositService = this.injector.get('Deposit');
        this.editView = _.get(this.rootScope.user, 'settings.core.use_light_version') ? 'light' : 'full';

        this.contactMediaDirectoryUuid = _.get(this.userStore, 'state.company.media.default_directories.contacts', null);

        this.deposits = {
            states: {}
        };
        this._loadDeposits();
    }

    _handleGuestlistSelect() {
        super._handleGuestlistSelect();

        this.setup();
    }

    _loadDeposits() {
        this.depositService.getRemoteDeposit('rsvps', 'states', []).then((value) => {
            this.deposits.states = value;
        });
    }

    setup() {
        this.params = this.stateParams.backParams || {};
        this.params.gid = this.guestlist.id;
        this.contacts = this.stateParams.contacts || this.injector.get('Contacts').reset({persist: false});
        this.store = this.stateParams.store;
        this.back = this.stateParams.back;

        this.rsvps = {
            contacts: this.contacts.getters.selectedFilters,
            guestlists: {
                filters: [
                    {
                        field: 'id',
                        operator: 'IN',
                        value: [this.guestlist.id]
                    }
                ],
                count: 1
            },
            fields: {
                status: _.get(this.userStore, 'state.company.settings.rsvps.default_status'),
                pax_max: 0,
                pax_planned: 1,
                pax_actual: 0,
                wants_shipping: _.get(this.userStore, 'state.company.settings.shipping.enable_shipping_on_rsvps_by_default')
            }
        };

        this.contactsSelector = {
            store: this.contacts,
            displayField: 'full_name',
            maxItems: 1000,
        }


        this.parentSelector = {
            store: this.injector.get('Rsvps').create('SelectorRsvps').reset({
                persist: false,
                permanentFilters: {'guestlist.id': this.guestlist.id}
            }),
            displayField: 'contact.full_name'
        };


        this.customFields = _(this.guestlist)
            .map((value, attr) => {
                if (attr.match(/custom_\d*_name/gi) && _.keys(value).length) {
                    value.key = attr.match(/custom_\d*/gi)[0];
                    return value;
                }
            })
            .filter()
            .value();


    }

    save() {

        this.rsvps.contacts.count = this.rsvps.contacts.count || this.rsvps.contacts.filters[0].value.length;

        // check for pax_planned value and set it to 1 if is not set or if is 0
        if (this.rsvps.fields.pax_planned == 0 || typeof this.rsvps.fields.pax_planned === "undefined") {
            this.rsvps.fields.pax_planned = 1;
        }

        this.api.post(`guestlists/contacts`, this.rsvps)
            .then(() => {
                this.alert.success('Rsvps Create', 'Your Rsvps have been successfully created');
                if (this.store) {
                    this.store.dispatch('getData');
                }
                this.close();
            }, err => this.alert.handle(err))
    }

    close() {
        const params = _.cloneDeep(this.params);
        params.store = this.store;
        this.state.go(this.back, params);
    }
}




// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/rsvps/rsvps-create-controller.js